import constants, { ACCESS_TOKEN, HTTP_METHODS } from "../../../settings/shared/constants";
import axiosClient from "../../common";

function _constructHeader() {
    const jwtToken = localStorage.getItem(ACCESS_TOKEN);

    return {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
    };
}

function filterMetrics(payload, page, size) {
    return axiosClient({
        url: constants.api.metrics.filter + "?page=" + page + "&size=" + size,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: payload,
    });
}

function createMetricCollection(payload) {
    return axiosClient({
        url: constants.api.metrics.create,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: payload,
    });
}

function getMetricCollection(id) {
    return axiosClient({
        url: constants.api.metrics.getById + id,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
    });
}

function updateMetricCollection(id, payload) {
    return axiosClient({
        url: constants.api.metrics.update + id,
        method: HTTP_METHODS.PUT,
        headers: _constructHeader(),
        data: payload,
    });
}

function deleteMetricCollection(id) {
    return axiosClient({
        url: constants.api.metrics.delete + id,
        method: HTTP_METHODS.DELETE,
        headers: _constructHeader(),
    });
}

const EvaluationMetricsService = {
    filterMetrics,
    createMetricCollection,
    getMetricCollection,
    updateMetricCollection,
    deleteMetricCollection,
};

export default EvaluationMetricsService;    